export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500italic-8dc5508832c2cd3a24a56e3734fde54f.svg";